import { render, staticRenderFns } from "./storeInputRecord.vue?vue&type=template&id=cdb1f224"
import script from "./storeInputRecord.vue?vue&type=script&lang=js"
export * from "./storeInputRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports